import { GetProp, TablePaginationConfig, TableProps } from 'antd';

import { Company } from 'models/Company';

export const PAGE_SIZE = 10;

export interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: string;
  sortOrder?: string;
  filters?: Parameters<GetProp<TableProps, 'onChange'>>[1];
}

/**
 * Body que los modales entregan a la escena. `create` agrega `countryCode` y
 * `password`; el resto de campos es idéntico en ambos endpoints, que reemplazan
 * en vez de parchear: todos viajan siempre.
 */
export interface CompanyFormPayload {
  name: string;
  isPrivate: boolean;
  kitIntegrationEnabled: boolean;
  kitCompanyIds: number[];
  tiendaPerfectaIntegrationEnabled: boolean;
  tiendaPerfectaCompanyCode: string | null;
  countryCode?: string;
}

export interface CompanyModalHandlers {
  openDetailModal: (row: Company) => void;
  openMenuDetailModal: (row: Company) => void;
  openChangePasswordModal: (row: Company) => void;
}
